(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["quick-add-bar-styles"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', (event) => {
    const select = event.target instanceof Element ? event.target.closest('[data-quick-add-bar-select]') : null;
    if (!select) return;
    const option = select.selectedOptions[0];
    const quickAdd = select.closest('.quick-add');
    const priceEl = quickAdd ? quickAdd.querySelector('.quick-add-bar__price') : null;
    if (priceEl && option && option.dataset.price) priceEl.textContent = option.dataset.price;
    const button = quickAdd ? quickAdd.querySelector('button[name="add"]') : null;
    if (button && option) button.disabled = option.disabled;
  });
  } catch(e) { console.error(e); }
})();

})();
